export enum TaskStatus {
  Pending = 'pending',
  Running = 'running',
  Completed = 'completed',
  Failed = 'failed',
  Dead = 'dead',
}

export interface TaskSummary {
  id: string;
  status: TaskStatus;
  runAt: Date;
  retryCount: number;
}
